<template>
  <ul class="role-ul" v-loading="fullLoading">
    <li class="hm-search">
      <!-- 查询部分 -->
      <el-form :inline="true" :model="searchForm">
        <el-form-item :label="$t('Components.System.Role.Search')">
          <el-input
            v-model="searchForm.inputSearch"
            :placeholder="$t('Components.System.Role.NameCode')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('Components.System.Role.Dataflag')">
          <el-select
            v-model="searchForm.dataflag"
            :placeholder="$t('Components.System.Role.SelectDataflag')"
            clearable
          >
            <el-option
              :label="$t('Components.System.Role.DataflagY')"
              value="true"
            />
            <el-option
              :label="$t('Components.System.Role.DataflagN')"
              value="false"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="buttonVisible.searchButton"
            type="primary"
            @click="queryClick"
            :icon="Search"
            >{{ $t("Components.System.Role.Search1") }}</el-button
          >
          <el-button
            v-if="buttonVisible.resetButton"
            @click="resetClick"
            :icon="RefreshLeft"
            >{{ $t("Components.System.Role.Reset") }}</el-button
          >
        </el-form-item>
      </el-form>
    </li>
    <li class="hm-operate">
      <!-- 操作部分 -->
      <el-button
        v-if="buttonVisible.addButton"
        :style="{ color: 'white' }"
        :icon="Plus"
        :color="ButtonColor.Add"
        @click="
          () => {
            dialogVisible = true;
          }
        "
        >{{ $t("Components.System.Role.Add") }}</el-button
      >
      <el-button
        v-if="buttonVisible.editButton"
        :disabled="!(selectRoles && selectRoles.length === 1)"
        :style="{ color: 'white' }"
        :icon="Edit"
        :color="ButtonColor.Edit"
        @click="handleEdit(1)"
        >{{ $t("Components.System.Role.Edit") }}</el-button
      >
      <el-button
        v-if="buttonVisible.copyButton"
        :disabled="!(selectRoles && selectRoles.length === 1)"
        :style="{ color: 'white' }"
        :icon="CopyDocument"
        :color="ButtonColor.Copy"
        @click="handleCopy(1)"
        >{{ $t("Components.System.Role.Copy") }}</el-button
      >
      <el-button
        v-if="buttonVisible.deleteButton"
        :disabled="!(selectRoles && selectRoles.length > 0)"
        :style="{ color: 'white' }"
        :icon="Delete"
        :color="ButtonColor.Delete"
        @click="handleDeleteBatch"
        >{{ $t("Components.System.Role.Delete") }}</el-button
      >
      <el-button
        v-if="buttonVisible.exportButton"
        :style="{ color: 'white' }"
        :icon="Download"
        :color="ButtonColor.Export"
        @click="handleExport"
        >{{ $t("Components.System.Role.Export") }}</el-button
      >
    </li>
    <el-scrollbar>
      <li class="hm-table">
        <!-- 表格部分 -->
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          row-key="guid"
          @sort-change="handleSortChange"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column
            prop="name"
            :label="$t('Components.System.Role.Name')"
          />
          <el-table-column
            prop="code"
            :label="$t('Components.System.Role.Code')"
          />
          <el-table-column
            sortable
            prop="sort"
            :label="$t('Components.System.Role.Sort')"
          />
          <el-table-column
            prop="dataflag"
            :label="$t('Components.System.Role.Dataflag')"
          >
            <template #default="scope">
              <el-switch
                :disabled="!buttonVisible.dataflag || scope.row.is_system"
                v-model="scope.row.dataflag"
                @change="(flag) => handleDataflagChange(flag, scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="createtime"
            sortable
            :label="$t('Components.System.Role.CreateTime')"
          />
          <el-table-column
            :label="$t('Components.System.Role.Operate')"
            width="240"
          >
            <template #default="scope">
              <el-space wrap v-if="!scope.row.is_system">
                <el-button
                  v-if="buttonVisible.copyButton"
                  :style="{ color: 'white' }"
                  :icon="CopyDocument"
                  :color="ButtonColor.Copy"
                  size="small"
                  @click="handleCopy(2, scope.row)"
                  >{{ $t("Components.System.Role.Copy") }}</el-button
                >
                <el-button
                  v-if="buttonVisible.editButton"
                  :style="{ color: 'white' }"
                  :icon="Edit"
                  :color="ButtonColor.Edit"
                  size="small"
                  @click="handleEdit(2, scope.row)"
                  >{{ $t("Components.System.Role.Edit") }}</el-button
                >
                <el-button
                  v-if="buttonVisible.deleteButton"
                  :style="{ color: 'white' }"
                  :icon="Delete"
                  :color="ButtonColor.Delete"
                  size="small"
                  bg
                  @click="handleDelete(scope.row)"
                  >{{ $t("Components.System.Role.Delete") }}</el-button
                >
              </el-space>
            </template>
          </el-table-column>
        </el-table>
      </li>
    </el-scrollbar>

    <li class="hm-page">
      <el-pagination
      small
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="AllPageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </li>
  </ul>
  <RoleModify
    v-if="dialogVisible"
    @handleCloseDialog="handleCloseDialog"
    :editData="editData"
    :lang="lang"
    @getRolePage="getRolePage"
  />
</template>
<script setup>
import { onMounted, reactive, ref, markRaw, watchEffect } from "vue";
import {
  RefreshLeft,
  Search,
  Edit,
  Plus,
  Delete,
  WarnTriangleFilled,
  CopyDocument,
  Download
} from "@element-plus/icons-vue";
import {
  request_role_page,
  request_role_dataflag,
  request_role_delete,
  request_role_delete_batch,
  request_role_copy,
  request_role_export
} from "@/api/apis";
import { DefaultPageSize } from "@/consts/frame";
import {
  AllPageSize,
  ButtonColor,
  LocalStorageKey,
  LangName,
} from "@/consts/frame";
import RoleModify from "@/components/System/Role/RoleModify.vue";
import { CheckType } from "@/consts/enum";
import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
import { useStore } from "@/store/index";
import { MenuCodes, MenuButtonCodes } from "@/consts/menuAndMenuButtonCode";
import { validateMenuButton } from "@/util/util";

const store = useStore();

const { t } = useI18n();
const searchForm = reactive({
  inputSearch: "",
  dataflag: undefined,
});
// 当前页码
const currentPage = ref(1);
// 页码大小
const pageSize = ref(DefaultPageSize);
// 表格数据
const tableData = ref([]);
// 表格加载
const tableLoading = ref(false);
// 总数量
const total = ref(0);
// 编辑的数据
const editData = ref({});
// 弹窗是否可见
const dialogVisible = ref(false);
// 语言
const lang = ref(localStorage.getItem(LocalStorageKey.Lang) || LangName.ZHCN);
// 选择的角色
const selectRoles = ref([]);
// 创建时间排序规则 如果为undefined 则没有这个参数，如果为true代表倒叙，为false代表正序
const createTimeSort = ref(undefined);
// 排序排序规则 如果为undefined 则没有这个参数，如果为true代表倒叙，为false代表正序
const sortSort = ref(undefined);

const buttonVisible = reactive({
  searchButton: false,
  resetButton: false,
  addButton: false,
  editButton: false,
  deleteButton: false,
  editButtonLine: false,
  deleteButtonLine: false,
  dataflag: false,
  copyButton: false,
  exportButton: false
});
// 全屏加载
const fullLoading = ref(false);
onMounted(async () => {
  await getRolePage();
});
// 分页查询角色
const getRolePage = async () => {
  const trans = {
    pagesize: pageSize.value,
    pageindex: currentPage.value,
    text: searchForm.inputSearch,
    dataflag: searchForm.dataflag,
    createTimeSort: createTimeSort.value,
    sort: sortSort.value,
  };
  tableLoading.value = true;
  const result = await request_role_page(
    trans,
    () => (tableLoading.value = false)
  );
  total.value = result.total;
  tableData.value = result.rows;
  selectRoles.value = [];
  editData.value = {};
};
// 查询事件
const queryClick = () => {
  getRolePage();
};
// 重置事件
const resetClick = () => {
  searchForm.dataflag = undefined;
  searchForm.inputSearch = "";
  getRolePage();
};
// 处理页码大小改变事件
const handleSizeChange = (size) => {
  pageSize.value = size;
  getRolePage();
};
// 处理当前页改变事件
const handleCurrentChange = (index) => {
  currentPage.value = index;
  getRolePage();
};

// 处理复制事件 type：1 代表操作栏复制；2：代表行内复制
const handleCopy = (type, data) => {
  let row = undefined;
  if (type === 1) {
    // 判断是否有且仅选择了一条用户数据
    if (selectRoles.value.length !== 1) {
      ElMessage.warning(t("Components.System.Role.OnlyOneSelectCopy"));
      return;
    }
    row = selectRoles.value[0];
  } else if (type === 2) {
    row = data;
  }
  ElMessageBox.confirm(
    t("Components.System.Role.ConfirmCopyRole"),
    t("Common.ElMessageBox.OperateConfirm"),
    {
      confirmButtonText: t("Common.ElMessageBox.ConfirmText"),
      cancelButtonText: t("Common.ElMessageBox.CancelText"),
      type: "warning",
      icon: markRaw(WarnTriangleFilled),
    }
  )
    .then(async () => {
      await request_role_copy({guid: row.guid}, true);
      getRolePage();
    })
    .catch(() => {});
};
// 处理编辑事件 type：1 代表操作栏编辑；2：代表行内编辑
const handleEdit = (type, data) => {
  let row = undefined;
  if (type === 1) {
    // 判断是否有且仅选择了一条用户数据
    if (selectRoles.value.length !== 1) {
      ElMessage.warning(t("Components.System.Role.OnlyOneSelectEdit"));
      return;
    }
    row = selectRoles.value[0];
  } else if (type === 2) {
    row = data;
  }
  // 筛选出全选中的节点数据
  const checkedGuids = [];
  if (row.menus && row.menus.length > 0) {
    row.menus.forEach((item) => {
      if (item.check_type === CheckType.Checked) {
        checkedGuids.push(item.menu_guid);
      }
    });
  }
  if (row.menuButtons && row.menuButtons.length > 0) {
    row.menuButtons.forEach((item) => {
      if (item.check_type === CheckType.Checked) {
        checkedGuids.push(item.menubutton_guid);
      }
    });
  }

  const checkedDepartmentGuids = [];
  if (row.rolePermissions && row.rolePermissions.length > 0) {
    row.rolePermissions.forEach((item) => {
      if (item.check_type === CheckType.Checked) {
        checkedDepartmentGuids.push(item.department_guid);
      }
    });
  }

  editData.value = {
    guid: row.guid,
    name: row.name,
    sort: row.sort,
    code: row.code,
    checkedGuids,
    data_permission_type: row.data_permission_type,
    checkedDepartmentGuids,
  };
  dialogVisible.value = true;
};
// 处理回调关闭事件
const handleCloseDialog = () => {
  dialogVisible.value = false;
  editData.value = {};
  // selectRoles.value = [];
};
// 处理有效性改变事件
const handleDataflagChange = async (flag, row) => {
  await request_role_dataflag(row.guid, true, () => {
    row.dataflag = !row.dataflag;
  });
  // getRolePage();
};
// 处理选择回调事件
const handleSelectionChange = (roles) => {
  selectRoles.value = roles;
};
// 处理删除
const handleDelete = async (row) => {
  ElMessageBox.confirm(
    t("Components.System.Role.ConfirmDeleteRole"),
    t("Common.ElMessageBox.OperateConfirm"),
    {
      confirmButtonText: t("Common.ElMessageBox.ConfirmText"),
      cancelButtonText: t("Common.ElMessageBox.CancelText"),
      type: "warning",
      icon: markRaw(WarnTriangleFilled),
    }
  )
    .then(async () => {
      await request_role_delete(row.guid, true);
      getRolePage();
    })
    .catch(() => {});
};
// 批量删除
const handleDeleteBatch = async () => {
  if(selectRoles.value.length === 0){
    ElMessage.warning(t("Components.System.Role.AtLeastOneRole"));
    return;
  }
  ElMessageBox.confirm(
    t("Components.System.Role.ConfirmDeleteRole"),
    t("Common.ElMessageBox.OperateConfirm"),
    {
      confirmButtonText: t("Common.ElMessageBox.ConfirmText"),
      cancelButtonText: t("Common.ElMessageBox.CancelText"),
      type: "warning",
      icon: markRaw(WarnTriangleFilled),
    }
  )
    .then(async () => {
      const trans = {
        guids: selectRoles.value.map((item) => item.guid),
      };
      await request_role_delete_batch(trans, true);
      getRolePage();
    })
    .catch(() => {});
};
// 处理排序改变事件
const handleSortChange = async ({ prop, order }) => {
  if (prop === "createtime") {
    sortSort.value = undefined;
    // 创建时间排序
    if (order === "ascending") {
      // 时间正序
      createTimeSort.value = false;
    } else if (order === "descending") {
      // 时间倒叙
      createTimeSort.value = true;
    } else {
      createTimeSort.value = undefined;
    }
  } else if (prop === "sort") {
    createTimeSort.value = undefined;
    // 序号排序
    if (order === "ascending") {
      // 序号正序
      sortSort.value = false;
    } else if (order === "descending") {
      // 序号倒叙
      sortSort.value = true;
    } else {
      sortSort.value = undefined;
    }
  }
  await getRolePage();
};

// 导出
const handleExport = async () => {
  fullLoading.value = true;
  const trans = {
    pagesize: pageSize.value,
    pageindex: currentPage.value,
    text: searchForm.inputSearch,
    dataflag: searchForm.dataflag,
    createTimeSort: createTimeSort.value,
    sort: sortSort.value,
  };
  const result = await request_role_export(
    trans,
    true,
    () => (fullLoading.value = false)
  );
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = result;
  link.target = '_blank'
  document.body.appendChild(link);
  link.click();
};
watchEffect(() => {
  if (store.userMenus) {
    // 处理查询
    buttonVisible.searchButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.Role,
      MenuButtonCodes.System.Role.RoleSearch
    );
    // 处理查询
    buttonVisible.resetButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.Role,
      MenuButtonCodes.System.Role.RoleReset
    );
    // 处理新增
    buttonVisible.addButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.Role,
      MenuButtonCodes.System.Role.RoleAdd
    );
    // 处理复制
    buttonVisible.copyButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.Role,
      MenuButtonCodes.System.Role.RoleCopy
    );
    // 处理编辑
    buttonVisible.editButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.Role,
      MenuButtonCodes.System.Role.RoleEdit
    );
    // 处理删除
    buttonVisible.deleteButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.Role,
      MenuButtonCodes.System.Role.RoleDelete
    );
    // 处理删除行
    buttonVisible.editButtonLine = validateMenuButton(
      store.userMenus,
      MenuCodes.System.Role,
      MenuButtonCodes.System.Role.RoleEditLine
    );
    // 处理删除行
    buttonVisible.deleteButtonLine = validateMenuButton(
      store.userMenus,
      MenuCodes.System.Role,
      MenuButtonCodes.System.Role.RoleDeleteLine
    );
    // 处理有效性
    buttonVisible.dataflag = validateMenuButton(
      store.userMenus,
      MenuCodes.System.Role,
      MenuButtonCodes.System.Role.RoleDataflag
    );
    // 处理导出
    buttonVisible.exportButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.Role,
      MenuButtonCodes.System.Role.RoleExport
    );
  }
});
</script>
<style>
.role-ul .el-scrollbar__view {
  height: calc(100% - 8px);
  /* overflow: hidden; */
}
</style>
<style scoped lang="scss">
.role-ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
